import { apiClient } from "@/lib/apiClient";
import {
  NotificationsResponse,
  NotificationUpdateRequest,
  MarkAllAsReadResponse,
  DeleteNotificationResponse,
} from "@/types/models/notification";

/**
 * Notification Service
 * Handles all notification-related API calls
 */

// GET /api/v1/admin/{storeId}/notifications
export const getNotifications = async (
  page: number = 1,
  limit: number = 20
) => {
  const params = {
    page: page.toString(),
    limit: limit.toString(),
  };

  return await apiClient.get<NotificationsResponse>(
    "/api/v1/admin/:storeId/notifications",
    { params }
  );
};

// PATCH /api/v1/admin/{storeId}/notifications/{notificationId}
export const markAsRead = async (
  notificationId: string,
  read: boolean = true
) => {
  const payload: NotificationUpdateRequest = { read };

  return await apiClient.patch(
    `/api/v1/admin/:storeId/notifications/${notificationId}`,
    payload
  );
};

// POST /api/v1/admin/{storeId}/notifications/mark-all-read
export const markAllAsRead = async () => {
  return await apiClient.post<MarkAllAsReadResponse>(
    "/api/v1/admin/:storeId/notifications/mark-all-read"
  );
};

// DELETE /api/v1/admin/{storeId}/notifications/{notificationId}
export const deleteNotification = async (notificationId: string) => {
  return await apiClient.delete<DeleteNotificationResponse>(
    `/api/v1/admin/:storeId/notifications/${notificationId}`
  );
};

// GET /api/v1/admin/{storeId}/notifications/unread-count
export const getUnreadCount = async () => {
  return await apiClient.get<{ unreadCount: number }>(
    "/api/v1/admin/:storeId/notifications/unread-count"
  );
};
